import * as React from "react";

const SolidTrashIcon = (props) => (
  <svg
    width={15}
    height={17}
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.125 4.25033H2.54167M2.54167 4.25033H13.875M2.54167 4.25033V14.167C2.54167 14.5427 2.69092 14.903 2.9566 15.1687C3.22228 15.4344 3.58261 15.5837 3.95833 15.5837H11.0417C11.4174 15.5837 11.7777 15.4344 12.0434 15.1687C12.3091 14.903 12.4583 14.5427 12.4583 14.167V4.25033H2.54167ZM4.66667 4.25033V2.83366C4.66667 2.45794 4.81592 2.0976 5.0816 1.83192C5.34728 1.56625 5.70761 1.41699 6.08333 1.41699H8.91667C9.29239 1.41699 9.65272 1.56625 9.9184 1.83192C10.1841 2.0976 10.3333 2.45794 10.3333 2.83366V4.25033"
      stroke="#D4001C"
      strokeWidth={1.67}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SolidTrashIcon;
